import { Link } from "@remix-run/react"
import { getRegionUrlPrefix } from "~/lib/helpers/slugHelper"

const GuideCard = ({ article, country }: any) => {
  const postUrl = `${getRegionUrlPrefix(article?.country !== null ? article?.country : country)}/blog/${article.slug}`;
  return (
    <div
      className="relative flex gap-4 border-b pb-4 group hover:shadow-sm transition"
    >
      <img
        src={`https://ik.imagekit.io/officehub/tr:h-240,fo-auto,f-avif/${article.image}`}
        alt={article.title}
        className="w-40 h-28 min-w-[10rem] object-cover rounded flex-shrink-0"
      />
      <div>
        <h3 className="font-semibold text-base mb-1 line-clamp-2">
          <Link
            to={postUrl}
            target="_blank"
            className="after:absolute after:inset-0 after:z-[1]"
          >
            {article.title}
          </Link>
        </h3>
        <p className="text-sm text-gray-600 mb-2 line-clamp-3 md:line-clamp-2" dangerouslySetInnerHTML={{ __html: article.blogContent }}></p>

        <span
          className="hidden md:block text-sm hover:underline relative z-[2] cursor-pointer"
          onClick={() => window.open(postUrl, "_blank")}
        >
          Read more
        </span>
      </div>
    </div>
  )
}

export default GuideCard